import React from "react";
import { Helmet } from "react-helmet-async";
import { Navbar, Footer, Breadcrumbs } from "../../components/shared";
import '../general/General.css';
import { useCheckAccess } from "../../utils/Utilities";
import MonthlyStatement from "../money/MonthlyStatement";
import { useSelector } from "react-redux";
const StatementsAdmin = () => {
  useCheckAccess('StatementsRO');
  const user = useSelector((state) => state.user);
  return (
    <>
      <Navbar />
      <Helmet>
        <title>ஸ்ரீ பொன்னாச்சி அம்மன் திருக்கோவில்கள் | Statements Admin</title>

      </Helmet>
      <>
        {user?.roles?.includes('StatementsRO') && (
          <div className="general_parent">
            <div className="general_container">
              <div className="general_body">
                <Breadcrumbs/>
                <MonthlyStatement />
              </div>
            </div>
          </div>
        )}

      </>
      <br />
      <Footer />
    </>
  );
};

export default StatementsAdmin;
